import { render, staticRenderFns } from "./mark-fee.vue?vue&type=template&id=b29a5386&"
import script from "./mark-fee.vue?vue&type=script&lang=js&"
export * from "./mark-fee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports